import useIsSnowflakeProduct from './useIsSnowflakeProduct'

export default useIsSnowflakeProduct
